import { jsxs as r, jsx as n, Fragment as O } from "react/jsx-runtime";
import { H3Heavy as D, BodyHeavy as v } from "../../styles/typography/index.js";
import { StampType as a } from "../CouponStamp/index.js";
import { Icon as s } from "../Icon/index.js";
import { MaskedButton as L } from "../MaskedButton/index.js";
import { Container as k, ActiveCouponCardHeader as H, ActiveCouponCardStamp as Y, ActiveCouponTitle as g, ButtonsContainer as V, ActivateButton as _, CouponButton as y } from "./style.js";
import { CouponCardAction as e } from "./types.js";
import { ArrowUpRightFromSquare as I } from "@pelando/fontawesome/icons";
const B = (t, o) => {
  const m = t === a.PRICE || t === a.DISCOUNT_FIXED || t === a.DISCOUNT_PERCENTAGE, i = (o || 0).toString().length, u = 4, C = 9;
  if (!(i < u || !m))
    return i < C ? D : v;
}, j = ({
  id: t,
  code: o,
  title: m,
  value: i,
  revealed: u,
  stampType: C,
  copyButtonLabel: d,
  ariaLabelIcon: S,
  MaskedButtonLabel: T,
  ActivateButtonLabel: c,
  actions: A,
  ...h
}) => {
  const l = (p) => () => {
    const E = { id: t };
    p === e.CLICK_TO_COPY && (E.coupon = o), A({ type: p, payload: E });
  }, f = () => u ? /* @__PURE__ */ r(O, { children: [
    /* @__PURE__ */ n(
      y,
      {
        coupon: o || "",
        onClick: l(e.CLICK_TO_COPY),
        copyButtonLabel: d,
        "aria-label": S,
        children: o
      }
    ),
    /* @__PURE__ */ r(
      _,
      {
        onClick: l(e.SEE_REVEALED_DEAL),
        title: c,
        children: [
          c,
          " ",
          /* @__PURE__ */ n(s, { icon: I })
        ]
      }
    )
  ] }) : /* @__PURE__ */ n(
    L,
    {
      responsive: !0,
      maskedContent: o || "",
      onClick: l(e.MASKED_CLICK),
      children: T
    }
  );
  return /* @__PURE__ */ r(k, { ...h, children: [
    /* @__PURE__ */ r(H, { children: [
      /* @__PURE__ */ n(
        Y,
        {
          type: C,
          value: i,
          valueStyle: B(C, i)
        }
      ),
      /* @__PURE__ */ n(g, { children: m })
    ] }),
    /* @__PURE__ */ r(V, { children: [
      o && f(),
      !o && /* @__PURE__ */ r(
        _,
        {
          onClick: l(e.ACTIVATE_DEAL),
          title: c,
          children: [
            c,
            " ",
            /* @__PURE__ */ n(s, { icon: I })
          ]
        }
      )
    ] })
  ] });
};
export {
  j as ActiveCouponCard,
  e as CouponCardAction,
  B as getValueStyle
};
